<template>
  <div>
    <div class="assessment_header">体测报告</div>
    <el-table
      class="table"
      :data="testReport"
      header-row-class-name="table-header"
    >
      <template #empty>
        <div style="height: 240px">
          <cl-no-data></cl-no-data>
        </div>
      </template>
      <el-table-column prop="name" label="体测名称" />
      <el-table-column prop="date" label="体测时间">
        <template #default="{ row }">
          <span class="table-date">{{ row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="source" label="来源"> </el-table-column>
    </el-table>
  </div>
</template>
  
<script>
export default {
  props: {
    testReport: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
  
<style lang="scss" scoped>
@import "../common-style.scss";
.table {
  min-height: 240px;
}
</style>